
<template>

    <div class="app-container" v-if="canList">
        <div class="filter-container">
<!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                      placeholder="名称"-->
<!--                      v-model="listQuery.name">-->
<!--            </el-input>-->
<!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                      placeholder="排序"-->
<!--                      v-model="listQuery.sort">-->
<!--            </el-input>-->
<!--            <el-input @keyup.enter.native="handleFilter" style="width: 200px;" class="filter-item input"-->
<!--                      placeholder="上级ID"-->
<!--                      v-model="listQuery.pid">-->
<!--            </el-input>-->
<!--            <el-select @change='handleFilter'  clearable class="filter-item input" style="width: 130px" v-model="listQuery.type"-->
<!--                       placeholder="类型">-->
<!--                <el-option v-for="(item,index) in  typeOptions" :key="item" :label="item" :value="index">-->
<!--                </el-option>-->
<!--            </el-select>-->

            <div style="display: inline-block">

<!--                <el-button style="margin-left: 10px;" class="filter-item" type="primary" v-waves icon="el-icon-search" @click="handleFilter">查找-->
<!--                </el-button>-->
                <el-button class="filter-item" style="margin-left: 10px;" @click="handleCreate" type="primary"
                           v-if="canSave"     icon="el-icon-edit">添加
                </el-button>
<!--                <el-button class="filter-item" type="primary" :loading="downloadLoading" v-waves icon="el-icon-download"-->
<!--                           @click="handleDownload">导出-->
<!--                </el-button>-->
            </div>
        </div>

        <el-table v-if="list" row-key="id" :key='tableKey' :tree-props="{children: 'children'}" :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;min-height:1000px;">
            <el-table-column align="center" label="ID">
                <template slot-scope="scope">
                    <span>{{scope.row.id}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="名称">
                <template slot-scope="scope">
                    <span>{{scope.row.name}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="排序">
                <template slot-scope="scope">
                    <span>{{scope.row.sort}}</span>
                </template>
            </el-table-column>
<!--            <el-table-column align="center" label="上级ID">-->
<!--                <template slot-scope="scope">-->
<!--                    <span>{{scope.row.pid}}</span>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column align="center" label="类型">
                <template slot-scope="scope">
                                                <span>

                         <el-tag  :type="tagTypes[scope.row.type]">     {{typeOptions[scope.row.type]}}</el-tag>

                        </span>
                </template>
            </el-table-column>

            <el-table-column align="center" label="操作" width="230" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button type="warning" :disabled="scope.row.type==1"  v-if="canUpdate"  size="mini" @click="handleAdd(scope)">扩展</el-button>
                    <el-button type="primary"  v-if="canUpdate"  size="mini" @click="handleUpdate(scope)">编辑</el-button>
                    <el-button  v-if="canSave"  size="mini" type="danger"
                                @click="handleDelete(scope)">删除
                    </el-button>
                </template>
            </el-table-column>

        </el-table>

        <div class="pagination-container">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="listQuery.page" :page-sizes="[10,20,30, 50]" :page-size="listQuery.limit"
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>

        <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form :rules="rules" ref="dataForm" :model="temp" label-position="left" label-width="120px"
                     style='width: 450px; margin-left:50px;'>
                <el-form-item label="名称" prop="name">
                    <el-input v-model="temp.name"></el-input>
                </el-form-item>
                <el-form-item label="排序" prop="sort">
                    <el-input v-model="temp.sort"></el-input>
                </el-form-item>
<!--                <el-form-item label="上级ID" prop="pid">-->
<!--                    <el-input v-model="temp.pid"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="类型" prop="status">-->
<!--                    <el-select class="filter-item" v-model="temp.type" placeholder="类型">-->
<!--                        <el-option v-for="(item,index) in  typeOptions" :key="item" :label="item"-->
<!--                                   :value="index">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
                <el-form-item label="图片" prop="img">
                    <el-upload
                            ref="imgUpload"
                            action="https://upload.qiniup.com"
                            :auto-upload="true"
                            list-type="picture-card"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="handleUpload"
                            :on-success="handleimgUploadSuccess"
                            :data="qData"
                            :file-list="imgList"
                            :on-remove="handleimgRemove">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>

                <el-dialog :visible.sync="dialogVisible" append-to-body>
                    <img width="100%" :src="dialogImageUrl" alt="">
                </el-dialog>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogForm">取消</el-button>
                <el-button v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
                <el-button v-else type="primary" @click="updateData">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<style type="stylus">
    .filter-container {
        /*padding-bottom: 20px;*/
    }
    .filter-item{
        margin-bottom :10px;
    }
    .filter-item.input{
        /*line-height: 60px*/
        margin-right :10px;
    }
</style>

<script>
    import {list, save, update, remove} from '@/api/mall_type'
    import waves from '@/directive/waves' // 水波纹指令

    import {getToken, domain} from '@/api/qiniu'
    import {listToStrs, strsToList} from '@/utils/imgUtil'

    import { mapGetters } from 'vuex'
    import { hasAuth } from '@/utils/auth'
    export default {
        name: 'test',
        directives: {
            waves
        },
        data() {
            return {
                tableKey: 0,
                list: null,
                total: null,
                listLoading: true,
                listQuery: {
                    page: 1,
                    limit: 20,
                    order: 'sort'
                    ,
                    name : null
                    ,
                    sort : null
                    ,
                    pid : null
                    ,
                    type : null
                },
                typeOptions : ["一级","二级"],
                tagTypes:['info','','warning','danger','warning'],
                temp:
                    {
                        id : null   ,                                    name : null   ,                                    type : null   ,                                    img : null   ,                                    sort : null   ,                                    pid : null                              }
                ,
                dialogFormVisible: false,
                dialogStatus
                    :
                    '',
                textMap
                    :
                    {
                        update: '修改',
                        create
                            :
                            '新增'
                    }
                ,
                // 存在图片
                dialogImageUrl: '',
                dialogVisible
                    :
                    false,
                imgList : [],
                rules:
                    {
                        name : [
                            {
                                required: false, message
                                    :
                                    '必填字段', trigger
                                    :
                                    'change'
                            }
                        ]
                        ,
                        type : [
                            {
                                required: false, message
                                    :
                                    '必填字段', trigger
                                    :
                                    'blur'
                            }
                        ]
                        ,
                        img : [
                            {
                                required: false, message
                                    :
                                    '必填字段', trigger
                                    :
                                    'change'
                            }
                        ]
                        ,
                        sort : [
                            {
                                required: false, message
                                    :
                                    '必填字段', trigger
                                    :
                                    'change'
                            }
                        ]
                        ,
                        pid : [
                            {
                                required: false, message
                                    :
                                    '必填字段', trigger
                                    :
                                    'change'
                            }
                        ]
                    }
                ,
                downloadLoading: false,
                qData
                    :
                    {
                        token: '',
                        key
                            :
                            ''
                    }
            }
        },
        created() {
            this.getList()
        },
        computed: {
            ...mapGetters([
                'perms'
            ]),
            canSave() {
                return hasAuth(this.perms, 'mall:type:save')
            },
            canDelete() {
                return hasAuth(this.perms, 'mall:type:delete')
            },
            canUpdate() {
                return hasAuth(this.perms, 'mall:type:update')
            },
            canList() {
                return hasAuth(this.perms, 'mall:type:list')
            }
        },
        methods: {
            getList() {
                this.listLoading = true
                list(this.listQuery).then(response => {
                    console.log(response.data)
                    this.list = response.data.list
                    this.total = response.data.total
                    this.listLoading = false
                })
            },
            handleFilter() {
                this.listQuery.page = 1
                this.getList()
            },
            handleSizeChange(val) {
                this.listQuery.limit = val
                this.getList()
            },
            handleCurrentChange(val) {
                this.listQuery.page = val
                this.getList()
            },
            handleModifyStatus(row, status) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                })
                row.status = status
            },
            beforeFormShow(row){
                this.resetTemp(row) // 更新数据
                // 存在图片
                this.initQiniu()

                // 存在图片字段转换图片地址显示
                this.initImgUrl()
            },
            afterFormShow(row){

            },
            beforeFormCommit(){
                this.initImgName()// 图片转换
            },
            resetTemp(row) {

                this.temp = {}
                if (row) {
                    this.temp = Object.assign({}, row) // copy obj
                    delete this.temp.children
                }

            },
            handleCreate() {
                this.beforeFormShow()
                this.resetTemp()
                this.dialogStatus = 'create'
                this.dialogFormVisible = true
                this.$nextTick(() => {
                    this.afterFormShow()
                    this.$refs['dataForm'].clearValidate()
                })
            },
            handleDelete(scope) {
                this.index = scope.$index
                // this.beforeFormShow(scope.row)
                // this.temp = Object.assign({}, row) // copy obj
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // this.$message({
                    //   type: 'success',
                    //   message: '删除成功!'
                    // })
                    this.deleteData(scope.row.id)
                }).
                catch((e) => {
                    console.log(e)
                    this.$message({
                        type: 'error',
                        message: '删除失败'
                    })
                })
            },
            // 显示将图片名封装成可以展示状态集合
            initImgUrl() {
                this.imgList = strsToList(this.temp.img, domain)
            },
            // 关闭显示窗口 重置图片地址 防止错乱
            resetImgUrl() {
                this.imgList = []
            },
            // 上传或者更新的时候从图片链接中获取图片名字
            initImgName() {
                this.temp.img = listToStrs(this.imgList)
            },
            createData() {
                this.$refs['dataForm'].validate((valid) => {
                        if(valid) {
                            this.beforeFormCommit()
                            if(!this.temp.type){
                                this.temp.type = 0
                            }
                        console.log(this.temp)
                            save(this.temp).then(res => {
                                this.temp = res.data
                                this.list.unshift(this.temp)
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '创建成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            deleteData(id) {
                // const ids = [this.temp.id]
                const ids = [id]
                remove({ids:ids}).then(res => {
                    // 从当前队列中移除
                    // this.list.splice(this.index, 1)
                    this.getList()
                    this.$notify({
                        title: '成功',
                        message: '删除成功',
                        type: 'success',
                        duration: 2000
                    })
                })
            },
            handleAdd(scope){
                // 存在图片
                this.beforeFormShow()
                this.temp.pid = scope.row.id
                this.temp.type = 1
                this.dialogStatus = 'create'
                this.dialogFormVisible = true
            },
            handleUpdate(scope) {
                this.index = scope.$index
                this.beforeFormShow(scope.row)
                this.dialogStatus = 'update'
                this.dialogFormVisible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].clearValidate()
                })
            },
            updateData() {
                this.$refs['dataForm'].validate((valid) => {
                        if(valid) {
                            this.beforeFormCommit()
                            update(this.temp).then(() => {
                                this.list.splice(this.index, 1, this.temp)
                                this.closeDialogForm()
                                this.$notify({
                                    title: '成功',
                                    message: '更新成功',
                                    type: 'success',
                                    duration: 2000
                                })
                            })
                        }
                    }
                )
            },
            closeDialogForm() {
                // 存在图片
                this.resetImgUrl()
                this.dialogFormVisible = false
            },
            handleDownload() {
                this.downloadLoading = true
                import('@/vendor/Export2Excel').then(excel => {
                    const tHeader = [
                        '序号'
                        ,
                        '名称'
                        ,
                        '排序'
                        ,
                        '上级ID'
                        ,
                        '类型'
                    ]
                    const filterVal = ['id'
                        ,'name'
                        ,'sort'
                        ,'pid'
                        ,
                        'type'
                    ]
                    const data = this.formatJson(filterVal, this.list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: 'table-list'
                    })
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => {
                        return v[j]
                    }
                ))
            },
            // 存在图片
            handleUpload(file) {
                this.qData.key = new Date().valueOf() + file.name
            },
            initQiniu() {
                // 获取七牛配置
                getToken().then(res => {
                    this.qData.token = res.data
                }).
                catch(error => {
                    console.log(error)
                })
            },
            handleimgUploadSuccess(response, file, fileList) {
                this.imgList.push({name: file.response.key, url: domain + file.response.key})
            }
            ,
            handleimgRemove (file, fileList) {
                for (var fn of this.imgList) {
                    if (fn.name === file.name) {
                        this.imgList.splice(this.imgList.indexOf(fn), 1)
                    }
                }
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url
                this.dialogVisible = true
            }
        }
    }
</script>
